

































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class ViewBox extends Vue {
  @Prop({ type: String, default: require("../assets/images/index/bj.png") })
  bj!: string;
  @Prop({ type: String, default: "view" })
  type!: string;
  @Prop({ type: String, default: require("../assets/images/rule/title.png") })
  titlimg!: string;
  @Prop({ type: Number, default: 111 })
  textTopHeader!: number;
  @Prop({ type: String, default: "auto" })
  textoverflow!: string;
  @Prop({ type: Number, default: 30 })
  textPadding!: number;

  mounted() {}
}
